import type { ReactNode } from 'react';
import { cn } from '@shared/utils';
import { Icon, Text } from '@shared/widgets';
import DotsIcon from '@assets/icons/dots.svg';

export interface IReportsChooseProps {
  className?: string;
  label: ReactNode;
  checked: boolean;
  onChange: () => void;
}

export const ReportsChoose = (props: IReportsChooseProps) => {
  return (
    <div className={cn('mb-4', 'hover:bg-ghost-white dark:hover:bg-light/5', props.className)}>
      <label className='flex items-center justify-between'>
        <input type='checkbox' className='hidden' checked={props.checked} onChange={props.onChange} />
        <div
          className={cn(
            'relative inline-flex h-6 w-11 cursor-pointer items-center rounded-full transition-colors duration-200',
            props.checked
              ? 'bg-primary hover:bg-primary/80'
              : 'bg-gainsborough hover:bg-gainsborough/70 dark:bg-gray-white dark:hover:bg-gray-white/70',
          )}
        >
          <span
            className={cn(
              'absolute h-5 w-5 rounded-full bg-white transition-transform duration-200',
              props.checked ? 'translate-x-5' : 'translate-x-1',
            )}
          />
        </div>
        <div className='order-[-1] flex cursor-grab items-center pr-2'>
          <Icon icon={<DotsIcon />} />
          <Text className='m-0' size='sm'>
            {props.label}
          </Text>
        </div>
      </label>
    </div>
  );
};
